export enum ClaimStatus {
  FeeForService = 'feeForService',
  CRO = 'cro',
  ValueBased = 'valueBased',
  Grant = 'grant',
  NotBillable = 'notBillable',
}
